{
  "name": "qiasphere-portal",
  "version": "1.13.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve qiasphere",
    "start:mock": "ng serve qiasphere --configuration=mock",
    "build": "ng build qiasphere",
    "test": "ng test",
    "test:ci": "ng test --configuration=ci",
    "qiasphere:test": "ng test",
    "eslint": "eslint --quiet --fix .",
    "e2e": "npx playwright test",
    "e2e:headed": "npx playwright test --headed",
    "e2e:docker": "scripts/e2e-docker.sh check",
    "e2e:docker:update": "scripts/e2e-docker.sh update",
    "lint": "eslint .",
    "lint:fix": "eslint --fix . && stylelint --fix \"**/*.scss\"",
    "stylelint": "stylelint \"**/*.scss\"",
    "prepare": "husky"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.18",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.18",
    "@angular/compiler": "^21.2.18",
    "@angular/core": "^21.2.18",
    "@angular/forms": "^21.2.18",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.18",
    "@angular/platform-browser-dynamic": "^21.2.18",
    "@angular/router": "^21.2.18",
    "@azure/msal-browser": "^5.10.1",
    "@microsoft/applicationinsights-web": "^2.8.18",
    "@qiagen/atlas-material": "^2.9.0",
    "@stomp/stompjs": "^7.3.0",
    "keyv": "^5.6.0",
    "material-icons": "1.13.12",
    "ngx-skeleton-loader": "11.3.0",
    "rxjs": "~7.8.1",
    "sockjs-client": "^1.6.1",
    "tslib": "^2.5.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.4.0",
    "@analogjs/vitest-angular": "^2.4.0",
    "@angular-devkit/schematics": "^21.2.5",
    "@angular/build": "^21.2.18",
    "@angular/cli": "^21.2.5",
    "@angular/compiler-cli": "^21.2.18",
    "@angular/language-service": "^21.2.18",
    "@babel/core": "^7.29.0",
    "@eslint/js": "^9.18.0",
    "@playwright/test": "^1.59.1",
    "@types/node": "^20.19.0",
    "@types/uuid": "^10.0.0",
    "@vitest/browser-playwright": "^4.1.2",
    "@vitest/coverage-v8": "^4.1.2",
    "@vitest/eslint-plugin": "^1.6.14",
    "angular-eslint": "^21.4.0",
    "eslint": "^9.39.4",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-perfectionist": "^5.9.1",
    "eslint-plugin-prettier": "^5.2.1",
    "husky": "9.0.11",
    "jsdom": "^29.0.1",
    "lint-staged": "15.2.7",
    "msw": "^2.15.0",
    "playwright": "^1.59.1",
    "prettier": "^3.3.3",
    "stylelint": "^17.14.0",
    "stylelint-config-sass-guidelines": "^13.0.0",
    "stylelint-order": "^8.1.1",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.62.1",
    "uuid": "^8.3.2",
    "vite-plugin-babel": "^1.6.0",
    "vitest": "^4.1.2",
    "webpack": "^5.93.0"
  },
  "nestjs-server-core": {},
  "husky": {
    "hooks": {
      "pre-commit": "lint-staged --relative"
    }
  },
  "lint-staged": {
    "*.{ts,html}": [
      "eslint --fix"
    ],
    "*.scss": [
      "stylelint --fix"
    ]
  },
  "msw": {
    "workerDirectory": [
      "mock"
    ]
  }
}
